import { createActions } from 'reduxsauce';
const { Types, Creators } = createActions({
  getListFilterINC: ['userName'],
  getListFilterINCSuccess: ['dataFilterINC'],
  getListFilterRITM: ['userName'],
  getListFilterRITMSuccess: ['dataFilterRITM'],
  getListFilterApproval: ['userName'],
  getListFilterApprovalSuccess: ['dataFilterApproval'],
});
export const FilterTypes = Types;
export default Creators;
